export default __webpack_public_path__ + "static/codeplatform-ai-3-ef02b0dd33ef1a424da19e94f6357440.png";